import { BannerMessage } from 'modules/common/components/_ui/BannerMessage/BannerMessage'
import { BannerProps } from '../_ui/Banner/Banner'

interface Props {
  onClose?: () => void
}

export const EmergencyBannerMessage = ({ onClose }: Props) => {
  const IS_EMERGENCY_BANNER_ENABLED = process.env
    .NEXT_PUBLIC_EMERGENCY_BANNER_ENABLED as string
  const EMERGENCY_BANNER_MESSAGE = process.env
    .NEXT_PUBLIC_EMERGENCY_BANNER_MESSAGE as string
  const EMERGENCY_BANNER_TYPE = process.env
    .NEXT_PUBLIC_EMERGENCY_BANNER_TYPE as BannerProps['type']

  if (IS_EMERGENCY_BANNER_ENABLED === 'true') {
    return (
      <BannerMessage type={EMERGENCY_BANNER_TYPE} onClose={onClose}>
        {EMERGENCY_BANNER_MESSAGE}
      </BannerMessage>
    )
  }

  return null
}
